import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { getProductPrice } from '~/utils/ProductPrice';
import { cacheControl } from '~/helpers/cacheControl';
import useRightPath from '~/composables/useRightPath';
import useLegacySeoMeta from '~/composables/useLegacySeoMeta';
import useGetBreadcrumbs from '~/composables/useGetBreadcrumbs';
import { useSegment } from '~/composables/_next/useSegment';
import { useProductListingStore } from '~/composables/_next/stores/useProductListingStore';
import { useWait } from '~/composables/_next/useWait';
import { useLocalization } from '~/composables/_next/useLocalization';
import { mergeMarketingBlocksWithProducts, transformMarketingBlockGraphql } from '~/helpers/contentful/marketingBlock';
import { formatDataForGtm, gtmDiscountValue } from '~/helpers/gtm';
import { getIsNewProduct, getVariants } from '~/helpers/productCardMethods';
import { PageTypes } from '~/types/PageTypes';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
import { isProductInStock } from '~/utils/ProductAvailability';
import AzRichText from '~/components/_next/atoms/AzRichText.vue';
import AzSeoBlock from '~/components/_next/molecules/AzSeoBlock.vue';
import ProductCardOrganism from '~/components/_next/organisms/ProductCardOrganism.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import CategoriesSisters from '~/components/Layout/CategoriesSisters.vue';
import AppCategoriesHeader from '~/components/Layout/AppCategoriesHeader.vue';
import MobileFiltersButton from '~/components/ui/CustomStoreFrontUI/MobileFiltersButton.vue';
import ItemMarketingBlock from '~/components/cms/custom/ItemMarketing/ItemMarketingBlock.vue';
import CategoryPageHeader from '~/components/Product/Category/CategoryPageHeader.vue';
import AzPagination from '~/components/_next/molecules/AzPagination.vue';
import AzBackToTopButton from '~/components/_next/atoms/AzBackToTopButton.vue';
import RelatedAdvicesOrganism from '~/components/_next/organisms/RelatedAdvicesOrganism.vue';
import RelatedRecipesOrganism from '~/components/_next/organisms/RelatedRecipesOrganism.vue';
import SearchFiltersOrganism from '~/components/_next/organisms/search/SearchFiltersOrganism.vue';
import AzSidebar from '~/components/_next/molecules/AzSidebar.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import { useSearchFacets } from '~/composables/_next/useSearchFacets';
import { getFacetSortOptions } from '~/composables/_next/facetGetters';
import ProductCardSkeleton from '~/assets/images/skeletons/product-card.svg?inline';
import { watchThrottled } from '@vueuse/core';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
const __nuxt_page_meta = {
  key: function key(route) {
        return route.params.slug;
      },middleware: ['live-preview', cacheControl('public, s-maxage=1800, stale-while-revalidate=300, stale-if-error=300') // 30 minutes cache and 5 minutes stale
      ],tracking: {
        category: TrackingPageCategory.PLP
      }
}
export default /*#__PURE__*/_defineComponent({
  ...__nuxt_page_meta,__name: '_slug',
  setup: function setup(__props) {
    ;
    var _useNuxt2App = useNuxt2App(),
      createError = _useNuxt2App.error,
      $trackers = _useNuxt2App.$trackers;
    var route = useRoute();
    var _useLegacySeoMeta = useLegacySeoMeta(),
      setMeta = _useLegacySeoMeta.setMeta,
      getOptionAttributeNamesFromFacets = _useLegacySeoMeta.getOptionAttributeNamesFromFacets;
    var _useRightPath = useRightPath(),
      getCanonicalUrl = _useRightPath.getCanonicalUrl;
    var _useSearchFacets = useSearchFacets(),
      facets = _useSearchFacets.facets,
      clearSearchFacets = _useSearchFacets.clearSearchFacets;
    var _useWait = useWait(),
      startWaiter = _useWait.startWaiter,
      endWaiter = _useWait.endWaiter,
      isWaiting = _useWait.isWaiting;
    var _useLocalization = useLocalization(),
      currency = _useLocalization.currency;
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR,
      trackDynamicYieldEvent = _useDynamicYield.trackDynamicYieldEvent;

    // TODO: Remove after Nuxt 3 migration
    onMounted(function () {
      var _useSegment = useSegment(),
        trackPage = _useSegment.trackPage;
      trackPage(TrackingPageCategory.PLP, PageTypes.PLP);
    });
    var _useProductListingSto = useProductListingStore(),
      fetchProductListingCategory = _useProductListingSto.fetchProductListingCategory,
      productListingCategory = _useProductListingSto.productListingCategory,
      productListingCategoryKey = _useProductListingSto.productListingCategoryKey,
      fetchProductListing = _useProductListingSto.fetchProductListing,
      productListing = _useProductListingSto.productListing,
      productListingFacets = _useProductListingSto.productListingFacets,
      productListingCategories = _useProductListingSto.productListingCategories;
    var fetchProductListingCategoryPromise = useLazyAsyncData("fetch-product-listing-category-".concat(route.params.slug), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _productListingCatego, _productListingCatego2, _productListingCatego3, _productListingCatego4, _productListingCatego5, _productListingCatego6, _productListingCatego7;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (route.params.slug) {
              _context.next = 3;
              break;
            }
            createError({
              statusCode: 404
            });
            return _context.abrupt("return", true);
          case 3:
            _context.next = 5;
            return fetchProductListingCategory();
          case 5:
            if (!isCategoryEmpty.value) {
              _context.next = 8;
              break;
            }
            createError({
              statusCode: 404
            });
            return _context.abrupt("return", true);
          case 8:
            if (productListingCategoryKey.value) {
              setDynamicYieldContext('CATEGORY', [productListingCategoryKey.value]);
              setDynamicYieldContextSSR('CATEGORY', [productListingCategoryKey.value]);
            }
            setMeta({
              title: (_productListingCatego = (_productListingCatego2 = productListingCategory.value) === null || _productListingCatego2 === void 0 ? void 0 : _productListingCatego2.metaTitle) !== null && _productListingCatego !== void 0 ? _productListingCatego : (_productListingCatego3 = productListingCategory.value) === null || _productListingCatego3 === void 0 ? void 0 : _productListingCatego3.name,
              description: (_productListingCatego4 = (_productListingCatego5 = productListingCategory.value) === null || _productListingCatego5 === void 0 ? void 0 : _productListingCatego5.metaDescription) !== null && _productListingCatego4 !== void 0 ? _productListingCatego4 : (_productListingCatego6 = productListingCategory.value) === null || _productListingCatego6 === void 0 ? void 0 : _productListingCatego6.description,
              canonical: getCanonicalUrl(),
              slug: (_productListingCatego7 = productListingCategory.value) === null || _productListingCatego7 === void 0 ? void 0 : _productListingCatego7.slug
            });
            return _context.abrupt("return", true);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var isCategoryEmpty = computed(function () {
      var _productListingCatego8;
      return !((_productListingCatego8 = productListingCategory.value) !== null && _productListingCatego8 !== void 0 && _productListingCatego8.key);
    });
    var _useLazyAsyncData = useLazyAsyncData("fetch-product-listing-".concat(route.params.slug), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (route.params.slug) {
                _context2.next = 3;
                break;
              }
              createError({
                statusCode: 404
              });
              return _context2.abrupt("return", true);
            case 3:
              _context2.next = 5;
              return fetchProductListing();
            case 5:
              return _context2.abrupt("return", true);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))),
      loading = _useLazyAsyncData.pending,
      refreshSearch = _useLazyAsyncData.refresh;
    watchThrottled(facets, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return refreshSearch();
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })), {
      throttle: 1000
    });
    watch(facets, function (facets, oldFacets) {
      if (oldFacets.page !== facets.page) {
        window.scrollTo(0, 0);
      }
    });
    var _useProductListingSto2 = useProductListingStore(),
      fetchProductListingContent = _useProductListingSto2.fetchProductListingContent,
      productListingContent = _useProductListingSto2.productListingContent,
      relatedAdvices = _useProductListingSto2.relatedAdvices,
      relatedRecipes = _useProductListingSto2.relatedRecipes,
      relatedRecipesDescription = _useProductListingSto2.relatedRecipesDescription;
    useLazyAsyncData("fetch-product-listing-content-".concat(route.params.slug), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (productListingCategoryKey.value) {
              _context4.next = 6;
              break;
            }
            if (!process.server) {
              _context4.next = 4;
              break;
            }
            _context4.next = 4;
            return fetchProductListingCategoryPromise;
          case 4:
            if (!process.client) {
              _context4.next = 6;
              break;
            }
            return _context4.abrupt("return", true);
          case 6:
            _context4.next = 8;
            return fetchProductListingContent();
          case 8:
            return _context4.abrupt("return", true);
          case 9:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })), {
      watch: [productListingCategoryKey]
    });
    var _useProductListingSto3 = useProductListingStore(),
      fetchProductListingRelatedCategories = _useProductListingSto3.fetchProductListingRelatedCategories,
      productListingRelatedCategories = _useProductListingSto3.productListingRelatedCategories;
    useLazyAsyncData("fetch-product-listing-related-categories-".concat(route.params.slug), /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (productListingCategoryKey.value) {
              _context5.next = 6;
              break;
            }
            if (!process.server) {
              _context5.next = 4;
              break;
            }
            _context5.next = 4;
            return fetchProductListingCategoryPromise;
          case 4:
            if (!process.client) {
              _context5.next = 6;
              break;
            }
            return _context5.abrupt("return", true);
          case 6:
            _context5.next = 8;
            return fetchProductListingRelatedCategories();
          case 8:
            return _context5.abrupt("return", true);
          case 9:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })), {
      watch: [productListingCategoryKey]
    });
    setDynamicYieldContextSSR('CATEGORY', [productListingCategoryKey.value]);
    var products = computed(function () {
      return getVariants(productListing.value);
    });
    useLazyAsyncData("gtm-product-listing-".concat(route.params.slug), function () {
      var _products$value, _productListingCatego9, _route$params, _route$params2, _productListingCatego0, _route$params3, _route$params4;
      if (!((_products$value = products.value) !== null && _products$value !== void 0 && _products$value.length) || loading.value) return true;
      $trackers.gtm.pushEvent('product_list_view', {
        event_category: 'ecommerce',
        event_action: 'impressions',
        event_label: (_productListingCatego9 = productListingCategory.value) === null || _productListingCatego9 === void 0 ? void 0 : _productListingCatego9.name,
        event_name: 'view_item_list',
        ecommerce: {
          item_list_id: formatDataForGtm((_route$params = route.params) === null || _route$params === void 0 ? void 0 : _route$params.slug),
          item_list_name: formatDataForGtm((_route$params2 = route.params) === null || _route$params2 === void 0 ? void 0 : _route$params2.slug),
          items: products.value.map(function (product, i) {
            return {
              item_id: "SKU_".concat(product.sku),
              item_sku: product.sku,
              item_name: (product === null || product === void 0 ? void 0 : product._name) || '',
              new_product: getIsNewProduct(product),
              discount: gtmDiscountValue(getProductPrice(product).regular, getProductPrice(product).special),
              discount_in_cents: gtmDiscountValue(getProductPrice(product).regular, getProductPrice(product).special, true),
              is_master_in_front: (product === null || product === void 0 ? void 0 : product._master) || '',
              ct_product_id: product === null || product === void 0 ? void 0 : product._id,
              index: i + 1,
              price: getProductPrice(product).regular,
              price_in_cents: Number((getProductPrice(product).regular * 100).toFixed(2)),
              currency: currency,
              is_in_stock: isProductInStock(product)
            };
          })
        }
      });
      trackDynamicYieldEvent({
        name: 'view_item_list',
        properties: {
          event_label: (_productListingCatego0 = productListingCategory.value) === null || _productListingCatego0 === void 0 ? void 0 : _productListingCatego0.name,
          item_list_id: formatDataForGtm((_route$params3 = route.params) === null || _route$params3 === void 0 ? void 0 : _route$params3.slug),
          item_list_name: formatDataForGtm((_route$params4 = route.params) === null || _route$params4 === void 0 ? void 0 : _route$params4.slug),
          items: products.value.map(function (product, i) {
            var _product$value;
            return {
              item_id: "SKU_".concat(product.sku),
              item_sku: product.sku,
              item_name: ((_product$value = product.value) === null || _product$value === void 0 ? void 0 : _product$value._name) || '',
              new_product: getIsNewProduct(product),
              discount: gtmDiscountValue(getProductPrice(product).regular, getProductPrice(product).special),
              discount_in_cents: gtmDiscountValue(getProductPrice(product).regular, getProductPrice(product).special, true),
              index: i + 1,
              price: getProductPrice(product).regular,
              price_in_cents: Number((getProductPrice(product).regular * 100).toFixed(2)),
              currency: currency,
              is_in_stock: isProductInStock(product)
            };
          })
        }
      });
      return true;
    }, {
      watch: [products, loading],
      server: false
    });
    var sidebar = ref(null);
    /**
     * Opens the filters sidebar.
     */
    function openSidebar() {
      sidebar.value.sidebar.showModal();
    }
    /**
     * Closes the filters sidebar.
     */
    function closeSidebar() {
      sidebar.value.sidebar.close();
    }
    function onClearFilters() {
      return _onClearFilters.apply(this, arguments);
    }
    function _onClearFilters() {
      _onClearFilters = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return clearSearchFacets();
            case 2:
              closeSidebar();
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      return _onClearFilters.apply(this, arguments);
    }
    var itemCount = computed(function () {
      var _totalProducts$value;
      return (_totalProducts$value = totalProducts.value) !== null && _totalProducts$value !== void 0 ? _totalProducts$value : pagination.value.totalProducts;
    });
    var sorting = computed(function () {
      return productListing.value.data ? getFacetSortOptions(productListing.value) : undefined;
    });
    var selectedSort = computed(function () {
      var currentSort = sorting.value.selected;
      var currentSortPosition = sorting.value.options.findIndex(function (sort) {
        return sort.id === currentSort;
      });
      return currentSortPosition !== 0 ? currentSort : undefined;
    });
    function changeSort(_x) {
      return _changeSort.apply(this, arguments);
    } // Legacy code
    function _changeSort() {
      _changeSort = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(sort) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              startWaiter('sort.change');
              _context7.next = 3;
              return fetchProductListing(sort);
            case 3:
              endWaiter('sort.change');
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return _changeSort.apply(this, arguments);
    }
    var maximumNumberOfCardsPerPage = 18;
    var isFilterButtonVisible = ref(true);
    var _useGetBreadcrumbs = useGetBreadcrumbs(),
      getCategoryBreadcrumbs = _useGetBreadcrumbs.getCategoryBreadcrumbs;
    var breadcrumbs = computed(function () {
      var _productListing$value, _productListing$value2;
      return getCategoryBreadcrumbs((_productListing$value = productListing.value) === null || _productListing$value === void 0 ? void 0 : (_productListing$value2 = _productListing$value.data) === null || _productListing$value2 === void 0 ? void 0 : _productListing$value2.currentCategory);
    });
    var toggleFilterButton = function toggleFilterButton() {
      isFilterButtonVisible.value = !isFilterButtonVisible.value;
    };

    /**
     * Ctnf Marketing blocks displayed among the products, limited to 2 maximum
     * "Item - Marketing Block" content type inside "Page - Product Listing Page" content type
     */
    var marketingBlocks = computed(function () {
      var _productListingConten, _productListingConten2;
      return transformMarketingBlockGraphql((_productListingConten = productListingContent.value) === null || _productListingConten === void 0 ? void 0 : (_productListingConten2 = _productListingConten.marketingBlockItemsCollection) === null || _productListingConten2 === void 0 ? void 0 : _productListingConten2.items);
    });
    var totalProducts = computed(function () {
      var _productListing$value3, _productListing$value4;
      return (_productListing$value3 = productListing.value) === null || _productListing$value3 === void 0 ? void 0 : (_productListing$value4 = _productListing$value3.data) === null || _productListing$value4 === void 0 ? void 0 : _productListing$value4.total;
    });
    var totalPages = computed(function () {
      if (totalProducts.value % maximumNumberOfCardsPerPage !== 0) {
        return Math.ceil(totalProducts.value / maximumNumberOfCardsPerPage);
      }
      return totalProducts.value / maximumNumberOfCardsPerPage;
    });
    var pagination = computed(function () {
      return {
        total: totalPages.value,
        totalProducts: totalProducts.value,
        totalPages: totalPages.value
      };
    });
    var seoBlock = computed(function () {
      var _productListingConten3, _productListingConten4, _productListingConten5, _productListingConten6, _productListingConten7;
      var description = (_productListingConten3 = productListingContent.value) === null || _productListingConten3 === void 0 ? void 0 : (_productListingConten4 = _productListingConten3.seoBlock) === null || _productListingConten4 === void 0 ? void 0 : (_productListingConten5 = _productListingConten4.content) === null || _productListingConten5 === void 0 ? void 0 : _productListingConten5.json;
      if (!description) return null;
      return {
        title: (_productListingConten6 = productListingContent.value) === null || _productListingConten6 === void 0 ? void 0 : (_productListingConten7 = _productListingConten6.seoBlock) === null || _productListingConten7 === void 0 ? void 0 : _productListingConten7.title,
        description: description
      };
    });
    var bannerImageUrl = computed(function () {
      var _productListingConten8, _productListingConten9;
      return (_productListingConten8 = productListingContent.value) === null || _productListingConten8 === void 0 ? void 0 : (_productListingConten9 = _productListingConten8.bannerImage) === null || _productListingConten9 === void 0 ? void 0 : _productListingConten9.url;
    });

    /**
     * Merge products & marketingBlocks into one list that will be displayed
     * We use a "type" key to know if it's a product or a marketing block
     */
    var shouldAddMarketingBlocksToListing = function shouldAddMarketingBlocksToListing(pageNumber) {
      // REFACTOR: Should remove isNaN test when we have refactored facets and ensure page number will always be defined
      if (!isNaN(pageNumber) && pageNumber > 1) {
        return false;
      }
      var hasProducts = products.value.length > 0;
      var hasMarketingBlocks = Array.isArray(marketingBlocks.value) && marketingBlocks.value.length > 0;
      return hasProducts && hasMarketingBlocks;
    };
    var activeItems = computed(function () {
      var _facets$value$page;
      var pageNumber = parseInt((_facets$value$page = facets.value.page) === null || _facets$value$page === void 0 ? void 0 : _facets$value$page[0]);
      if (shouldAddMarketingBlocksToListing(pageNumber)) {
        return mergeMarketingBlocksWithProducts(marketingBlocks.value, products.value);
      }
      return products.value;
    });
    var isCustomVariant = function isCustomVariant(item) {
      return item && _typeof(item) === 'object' && !('type' in item);
    };
    var isMarketingBlock = function isMarketingBlock(item) {
      return item && _typeof(item) === 'object' && 'type' in item && 'value' in item;
    };
    var filteredParamNames = computed(function () {
      // get all query parameters that can be set from facets
      return ['min-price', 'max-price'].concat(_toConsumableArray(getOptionAttributeNamesFromFacets(productListingFacets.value)));
    });
    return {
      __sfc: true,
      createError: createError,
      $trackers: $trackers,
      route: route,
      setMeta: setMeta,
      getOptionAttributeNamesFromFacets: getOptionAttributeNamesFromFacets,
      getCanonicalUrl: getCanonicalUrl,
      facets: facets,
      clearSearchFacets: clearSearchFacets,
      startWaiter: startWaiter,
      endWaiter: endWaiter,
      isWaiting: isWaiting,
      currency: currency,
      setDynamicYieldContext: setDynamicYieldContext,
      setDynamicYieldContextSSR: setDynamicYieldContextSSR,
      trackDynamicYieldEvent: trackDynamicYieldEvent,
      fetchProductListingCategory: fetchProductListingCategory,
      productListingCategory: productListingCategory,
      productListingCategoryKey: productListingCategoryKey,
      fetchProductListing: fetchProductListing,
      productListing: productListing,
      productListingFacets: productListingFacets,
      productListingCategories: productListingCategories,
      fetchProductListingCategoryPromise: fetchProductListingCategoryPromise,
      isCategoryEmpty: isCategoryEmpty,
      loading: loading,
      refreshSearch: refreshSearch,
      fetchProductListingContent: fetchProductListingContent,
      productListingContent: productListingContent,
      relatedAdvices: relatedAdvices,
      relatedRecipes: relatedRecipes,
      relatedRecipesDescription: relatedRecipesDescription,
      fetchProductListingRelatedCategories: fetchProductListingRelatedCategories,
      productListingRelatedCategories: productListingRelatedCategories,
      products: products,
      sidebar: sidebar,
      openSidebar: openSidebar,
      closeSidebar: closeSidebar,
      onClearFilters: onClearFilters,
      itemCount: itemCount,
      sorting: sorting,
      selectedSort: selectedSort,
      changeSort: changeSort,
      maximumNumberOfCardsPerPage: maximumNumberOfCardsPerPage,
      isFilterButtonVisible: isFilterButtonVisible,
      getCategoryBreadcrumbs: getCategoryBreadcrumbs,
      breadcrumbs: breadcrumbs,
      toggleFilterButton: toggleFilterButton,
      marketingBlocks: marketingBlocks,
      totalProducts: totalProducts,
      totalPages: totalPages,
      pagination: pagination,
      seoBlock: seoBlock,
      bannerImageUrl: bannerImageUrl,
      shouldAddMarketingBlocksToListing: shouldAddMarketingBlocksToListing,
      activeItems: activeItems,
      isCustomVariant: isCustomVariant,
      isMarketingBlock: isMarketingBlock,
      filteredParamNames: filteredParamNames,
      AzRichText: AzRichText,
      AzSeoBlock: AzSeoBlock,
      ProductCardOrganism: ProductCardOrganism,
      AzIcon: AzIcon,
      CategoriesSisters: CategoriesSisters,
      AppCategoriesHeader: AppCategoriesHeader,
      MobileFiltersButton: MobileFiltersButton,
      ItemMarketingBlock: ItemMarketingBlock,
      CategoryPageHeader: CategoryPageHeader,
      AzPagination: AzPagination,
      AzBackToTopButton: AzBackToTopButton,
      RelatedAdvicesOrganism: RelatedAdvicesOrganism,
      RelatedRecipesOrganism: RelatedRecipesOrganism,
      SearchFiltersOrganism: SearchFiltersOrganism,
      AzSidebar: AzSidebar,
      AzButton: AzButton,
      ProductCardSkeleton: ProductCardSkeleton
    };
  }
});